"use client";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { EXTERNAL_URLS } from "@/utils/lms-navigation";
interface RedirectionContainerProps {
	title?: string;
	description?: string;
	targetLink: keyof typeof EXTERNAL_URLS;
}
const RedirectionContainer: React.FC<RedirectionContainerProps> = ({
	title = "Chuyển hướng",
	description = "Bạn đang được chuyến hướng đến trang đích.",
	targetLink,
}) => {
	const router = useRouter();
	useEffect(() => {
		const timeOutId = setTimeout(() => {
			window.open(EXTERNAL_URLS[targetLink], "_blank");
			router.push("/");
			clearTimeout(timeOutId);
		}, 1000);

		return () => {
			clearTimeout(timeOutId);
		};
	}, []);

	return (
		<div className="redirection-container">
			<div className="text-center">
				<h3 className="text-xl font-semibold mb-4">{title}</h3>
				<p className="text-gray-600">{description}</p>
			</div>
		</div>
	);
};
export default RedirectionContainer;
